import React from 'react';
import { Text } from 'src/modules/shared/components/atoms/text';
import { PiTimer } from 'react-icons/pi';
import Tag from 'src/modules/shared/components/atoms/tag';
import Tooltip from 'src/modules/shared/components/atoms/tooltips/tooltip';

interface OverdueTasksIndicatorProps {
  count: number;
  className?: string;
}

export const OverdueTasksIndicator: React.FC<OverdueTasksIndicatorProps> = ({
  count,
  className = '',
}) => {
  if (count <= 0) {
    return null;
  }

  const content = (
    <div className="flex items-center gap-1">
      <PiTimer className="h-3.5 w-3.5" />

      <Text size="tiny" className="font-medium hidden lg:inline">
        {/* TODO: check when implementing i18n */}
        {count} {count === 1 ? 'tarea vencida' : 'tareas vencidas'}
      </Text>

      <Text size="tiny" className="font-medium lg:hidden">
        {count}
      </Text>
    </div>
  );

  return (
    <Tooltip
      // TODO: check when implementing i18n
      content={`${count} ${count === 1 ? 'tarea vencida' : 'tareas vencidas'}`}
      placement="top"
      size="sm"
    >
      <Tag
        content={content}
        variant="danger"
        appearance="outline"
        size="sm"
        className={`${className} cursor-default`}
      />
    </Tooltip>
  );
};
